import React from "react";
import PropTypes from "prop-types";
import Card from "../card";
import { Link, navigate } from "gatsby";
import { convertToHumanReadable } from "../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { inline_header } from "./styles.module.scss";

function FeaturedPostsRow(props) {
  // Select the data based on the type of featured content, escape if none is found
  const contentTypeData = props.content_types.data?.[0]?.attributes;
  const tagData = props.tag.data?.attributes;
  const topicData = props.topic.data?.attributes;
  const featuredData = contentTypeData || tagData || topicData;
  if (!featuredData) {
    return null;
  }

  // Normalize the data for the card component
  const normalizedData = featuredData.posts.data.map((post) => {
    return {
      tags: post.attributes.tags.data.map((tag) => {
        return { label: tag.attributes.name };
      }),
      types: post.attributes.categories.data.map((category) => {
        return { label: category.attributes.name };
      }),
      topics: post.attributes.topics.data.map((topic) => {
        return {
          label: topic.attributes.name,
          value: topic.attributes.page?.data.attributes.slug
        };
      }),
      path: post.attributes.slug,
      title: post.attributes.seo_title,
      publishDate: post.attributes.publish_date,
      thumbnail: post.attributes.case_study_metadata.thumbnail.data.attributes
    };
  });

  // TODO this should be handled as a link instead of a button
  const handleSelect = (section, label) => {
    if (section === "topics") {
      navigate(`/knowledge-hub/topic/${label}`);
    } else {
      navigate(`/knowledge-hub/?${section}=${label}`);
    }
  };

  const getViewAllLink = () => {
    if (contentTypeData) {
      return `/knowledge-hub?types=${contentTypeData.name}`;
    } else if (tagData) {
      return `/knowledge-hub?tags=${tagData.name}`;
    } else {
      return `/knowledge-hub/topic/${topicData.page.data.attributes.slug}`;
    }
  };

  const component = (
    <div className="container-wrapper py-6 container-lg col-sm-10 col-md-12 p-responsive height-full">
      <div className={`m-2 header-container ${inline_header}`}>
        <h2>{convertToHumanReadable(featuredData.name)}</h2>
        <Link to={getViewAllLink()}>
          <span>View All</span>
          <FontAwesomeIcon icon={faAngleRight} />
        </Link>
      </div>

      <div className={`d-flex flex-column flex-lg-row height-full `}>
        {normalizedData.map((post, index) => {
          return (
            <div key={index} className="padding-r">
              <Card src={post.thumbnail.url} handleSelect={handleSelect} {...post} />
            </div>
          );
        })}
      </div>
    </div>
  );

  return props.background_color ? (
    <div style={{ backgroundColor: props.background_color }}>{component}</div>
  ) : (
    component
  );
}

FeaturedPostsRow.propTypes = {
  content_types: PropTypes.object,
  tag: PropTypes.object,
  topic: PropTypes.object,
  background_color: PropTypes.string,
  post: PropTypes.objectOf({
    thumbnail: PropTypes.objectOf({
      url: PropTypes.string
    })
  })
};

export default FeaturedPostsRow;
